export const PRODUCT_TYPE_ID = {
  VOICE_ONLY_RES: '147e55f6-8f33-42b0-b868-6750cee05047',
  VOICE_ONLY_SMB: '46ba97d2-8619-4318-a8aa-ae452efbf728',
  UNLEASHED_MAX: '5377b6e7-2e6f-489e-b820-d8be51a26c7a',
};
